import apiClient from '../axiosConfig';
import { components } from '../types/openapi';

// Tipos del OpenAPI
type CountryResponse = components['schemas']['CountryResponse'];
type CreateCountry = components['schemas']['CreateCountry'];
type UpdateCountry = components['schemas']['UpdateCountry'];
type PaginationCountryResponse = components['schemas']['Pagination_CountryResponse_'];

/**
 * Servicio de gestión de países
 * Maneja todas las operaciones CRUD de países
 * Basado en los endpoints del OpenAPI
 */
class CountryService {
  /**
   * Obtener países con paginación
   * GET /api/common/country/pagination
   */
  async getCountriesPaginated(params?: {
    page?: number;
    limit?: number;
    name?: string;
  }): Promise<PaginationCountryResponse> {
    const response = await apiClient.get<PaginationCountryResponse>('/common/country/pagination', { params });
    return response.data;
  }

  /**
   * Obtener un país por ID
   * GET /api/common/country/{country_id}
   */
  async getCountryById(countryId: number): Promise<CountryResponse> {
    const response = await apiClient.get<CountryResponse>(`/common/country/${countryId}`);
    return response.data;
  }

  /**
   * Crear un país
   * POST /api/common/country/
   */
  async createCountry(body: CreateCountry): Promise<CountryResponse> {
    const response = await apiClient.post<CountryResponse>('/common/country/', body);
    return response.data;
  }

  /**
   * Actualizar un país
   * PUT /api/common/country/
   */
  async updateCountry(body: UpdateCountry): Promise<CountryResponse> {
    const response = await apiClient.put<CountryResponse>('/common/country/', body);
    return response.data;
  }

  /**
   * Eliminar un país
   * DELETE /api/common/country/{country_id}
   */
  async deleteCountry(countryId: number): Promise<void> {
    await apiClient.delete(`/common/country/${countryId}`);
  }

  /**
   * Verificar si se puede eliminar un país
   * GET /api/common/country/check-delete/{country_id}
   */
  async checkDeleteCountry(countryId: number): Promise<{ can_delete: boolean }> {
    const response = await apiClient.get<{ can_delete: boolean }>(`/common/country/check-delete/${countryId}`);
    return response.data;
  }

  /**
   * Cambiar estado de un país
   * POST /api/common/country/change-state/{country_id}
   */
  async changeCountryState(countryId: number): Promise<CountryResponse> {
    const response = await apiClient.post<CountryResponse>(`/common/country/change-state/${countryId}`);
    return response.data;
  }

  /**
   * Obtener todos los países activos
   * GET /api/common/country/all-active
   */
  async getAllActiveCountries(params?: {
    name?: string;
  }): Promise<CountryResponse[]> {
    const response = await apiClient.get<CountryResponse[]>('/common/country/all-active', { params });
    return response.data;
  }

  /**
   * Obtener todos los países
   * GET /api/common/country/all
   */
  async getAllCountries(params?: {
    name?: string;
  }): Promise<CountryResponse[]> {
    const response = await apiClient.get<CountryResponse[]>('/common/country/all', { params });
    return response.data;
  }
}

export default new CountryService();

